import React from 'react';
import clsx from 'clsx';
import {Link} from 'components/Link';
import {useNavigate, useLocation} from '@remix-run/react';
// import Slider from '@mui/material/Slider';
import {useLoaderData} from '@remix-run/react';
import {Slider} from './RangeSlider';

//domains
import type {FilterOption, PriceRange} from 'domains/collections';
import {filterInputToParams} from 'domains/collections';
import {loader} from '~/routes/($lang)/collections/$collectionHandle';

export default function FilterOption({o}: {o: FilterOption}) {
  switch (o.filterOptionId) {
    case 'pf_v_brand':
      return <OptionList o={o} />;
    case 'pf_st_stock_status':
      return <OptionList o={o} />;
    case 'pf_opt_size':
      return <OptionList o={o} />;
    case 'pf_t_color':
      return <OptionSwatch o={o} />;
    case 'pf_t_style':
      return <OptionList o={o} />;
    case 'pf_t_tag':
      return <OptionList o={o} />;
    case 'pf_p_price':
      return <OptionPriceRange o={o} />;
    default:
      return <OptionList o={o} />;
  }
}

const helmetSizes = [
  'SIZE 3XS',
  'SIZE 2XS',
  'SIZE XS',
  'SIZE S',
  'SIZE M',
  'SIZE L',
  'SIZE XL',
  'SIZE 2XL',
  'SIZE 3XL',
  'SIZE FREE',
];

const gloveSizes = [
  'SIZE XS',
  'SIZE S',
  'SIZE M',
  'SIZE L',
  'SIZE XL',
  'SIZE 2XL',
  'SIZE 3XL',
  'T6',
  'T7',
  'T8',
  'T9',
  'T10',
  'T11',
  'T12',
  'T13',
];

const clothingSizes = [
  'SIZE XXS',
  'SIZE XS',
  'SIZE S',
  'SIZE M',
  'SIZE L',
  'SIZE XL',
  'SIZE 2XL',
  'SIZE 3XL',
];

const jeanSizes = [
  'SIZE 36',
  'SIZE 38',
  'SIZE 40',
  'SIZE 42',
  'SIZE 44',
  'SIZE 46',
  'SIZE 48',
  'SIZE 50',
  'SIZE 52',
  'SIZE 54',
  'SIZE 56',
  'SIZE 58',
  'SIZE 60',
];

const pantSizes = [
  'SIZE 26',
  'SIZE 27',
  'SIZE 28',
  'SIZE 29',
  'SIZE 30',
  'SIZE 31',
  'SIZE 32',
  'SIZE 33',
  'SIZE 34',
  'SIZE 35',
  'SIZE 36',
  'SIZE 37',
  'SIZE 38',
  'SIZE 39',
  'SIZE 40',
  'SIZE XS',
  'SIZE S',
  'SIZE M',
  'SIZE L',
  'SIZE XL',
  'SIZE 2XL',
];

const shoeSizes = [
  'SIZE EU-36',
  'SIZE EU-37',
  'SIZE EU-38',
  'SIZE EU-39',
  'SIZE EU-40',
  'SIZE EU-41',
  'SIZE EU-42',
  'SIZE EU-43',
  'SIZE EU-44',
  'SIZE EU-45',
  'SIZE EU-46',
  'SIZE EU-47',

  'SIZE US-5',
  'SIZE US-5.5',
  'SIZE US-6',
  'SIZE US-6.5',
  'SIZE US-7',
  'SIZE US-7.5',
  'SIZE US-8',
  'SIZE US-8.5',
  'SIZE US-9',
  'SIZE US-9.5',
  'SIZE US-10',
  'SIZE US-10.5',
  'SIZE US-11',
  'SIZE US-11.5',
  'SIZE US-12',
  'SIZE US-12.5',
  'SIZE US-13',

  'SIZE JP-23',
  'SIZE JP-23.5',
  'SIZE JP-24',
  'SIZE JP-24.5',
  'SIZE JP-25',
  'SIZE JP-25.5',
  'SIZE JP-26',
  'SIZE JP-26.5',
  'SIZE JP-27',
  'SIZE JP-27.5',
  'SIZE JP-28',
  'SIZE JP-28.5',
  'SIZE JP-29',
  'SIZE JP-29.5',
  'SIZE JP-30',
  'SIZE JP-30.5',
  'SIZE JP-31',
  'SIZE JP-31.5',
  'SIZE JP-32',
  'SIZE JP-32.5',
  'SIZE JP-33',
];

const allSizes = [
  'SIZE 3XS',
  'SIZE 2XS',
  'SIZE XXS',
  'SIZE XS',
  'SIZE S',
  'SIZE M',
  'SIZE L',
  'SIZE XL',
  'SIZE 2XL',
  'SIZE 3XL',
  'SIZE FREE',
  'T6',
  'T7',
  'T8',
  'T9',
  'T10',
  'T11',
  'T12',
  'T13',
  'SIZE 26',
  'SIZE 27',
  'SIZE 28',
  'SIZE 29',
  'SIZE 30',
  'SIZE 31',
  'SIZE 32',
  'SIZE 33',
  'SIZE 34',
  'SIZE 35',
  'SIZE 36',
  'SIZE 37',
  'SIZE 38',
  'SIZE 39',
  'SIZE 40',
  'SIZE 42',
  'SIZE 44',
  'SIZE 46',
  'SIZE 48',
  'SIZE 50',
  'SIZE 52',
  'SIZE 54',
  'SIZE 56',
  'SIZE 58',
  'SIZE 60',
  'SIZE EU_36',
  'SIZE EU_37',
  'SIZE EU_38',
  'SIZE EU_39',
  'SIZE EU_40',
  'SIZE EU_41',
  'SIZE EU_42',
  'SIZE EU_43',
  'SIZE EU_44',
  'SIZE EU_45',
  'SIZE EU_46',
  'SIZE EU_47',
  'SIZE US_5',
  'SIZE US_5.5',
  'SIZE US_6',
  'SIZE US_6.5',
  'SIZE US_7',
  'SIZE US_7.5',
  'SIZE US_8',
  'SIZE US_8.5',
  'SIZE US_9',
  'SIZE US_9.5',
  'SIZE US_10',
  'SIZE US_10.5',
  'SIZE US_11',
  'SIZE US_11.5',
  'SIZE US_12',
  'SIZE US_12.5',
  'SIZE US_13',
  'SIZE JP_23',
  'SIZE JP_23.5',
  'SIZE JP_24',
  'SIZE JP_24.5',
  'SIZE JP_25',
  'SIZE JP_25.5',
  'SIZE JP_26',
  'SIZE JP_26.5',
  'SIZE JP_27',
  'SIZE JP_27.5',
  'SIZE JP_28',
  'SIZE JP_28.5',
  'SIZE JP_29',
  'SIZE JP_29.5',
  'SIZE JP_30',
  'SIZE JP_30.5',
  'SIZE JP_31',
  'SIZE JP_31.5',
  'SIZE JP_32',
  'SIZE JP_32.5',
  'SIZE JP_33',
];

function OptionList({o}: {o: FilterOption}) {
  const {tagTranslation} = useLoaderData<typeof loader>();
  const location = useLocation();
  const params = React.useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const navigate = useNavigate();
  const allSelectedOptions = params.getAll(o.filterOptionId);
  const isPercentageSale = o.filterOptionId === 'pf_ps_percent_sale';
  const tagTranslated = tagTranslation as any;

  // o.filterOptionId === 'pf_t_helmet_others' && console.log(o);

  return (
    <div className={clsx(['grid gap-3'])}>
      {Array.isArray(o.values) &&
        o.values
          .sort((a, b) => {
            return `${a.key}`.localeCompare(`${b.key}`);
          })
          // .sort(
          //   (a, b) => helmetSizes.indexOf(a.key) - helmetSizes.indexOf(b.key),
          // )
          // .sort((a, b) => gloveSizes.indexOf(a.key) - gloveSizes.indexOf(b.key))
          // .sort(
          //   (a, b) =>
          //     clothingSizes.indexOf(a.key) - clothingSizes.indexOf(b.key),
          // )
          // .sort((a, b) => jeanSizes.indexOf(a.key) - jeanSizes.indexOf(b.key))
          // .sort((a, b) => pantSizes.indexOf(a.key) - pantSizes.indexOf(b.key))
          .sort((a, b) => allSizes.indexOf(a.key) - allSizes.indexOf(b.key))
          .map((v, i) => {
            if (v.key === '*-1') return <></>;

            //In Stock, the key is 'out-of-stock'
            //coz default is in-stock

            const translatedKey = tagTranslated[v.key] ?? v.key;
            // o.filterOptionId === 'pf_t_rider_style' && console.log(v.key);
            // o.filterOptionId === 'pf_t_rider_style' && console.log(translatedKey);

            if (o.filterOptionId === 'pf_c_collection') {
              const translatedKey =
                (v.handle && tagTranslated[v.handle]) ??
                tagTranslated[v.key] ??
                v.label ??
                v.key;
              return (
                <Link
                  to={`/collections/${v.handle}?pf_v_brand=${params.get(
                    'pf_v_brand',
                  )}`}
                  key={`${v.key}-${i}`}
                >
                  <div className="flex cursor-pointer items-center space-x-2">
                    <div className="flex h-[15px] w-[15px] items-center justify-center border-[1px] border-solid border-black p-[2px]">
                      {allSelectedOptions.includes(v.key) ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-full"
                          viewBox="0 0 24 24"
                        >
                          <path d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z" />
                        </svg>
                      ) : null}
                    </div>
                    <div className="cursor-pointer font-light text-left">
                      {translatedKey} {`(${v?.doc_count ?? 0})`}
                    </div>
                  </div>
                </Link>
              );
            }

            return (
              <button
                onClick={() => {
                  const stockStatusKey =
                    o.filterOptionId === 'pf_st_stock_status' && 'out-of-stock';
                  const newParams = filterInputToParams(
                    'LIST',
                    {
                      val: stockStatusKey
                        ? stockStatusKey
                        : isPercentageSale && v.key === '*-1'
                        ? ':1'
                        : isPercentageSale && v.key === '1-*'
                        ? '1:'
                        : v.key,
                    },
                    params,
                    o.filterOptionId,
                  );
                  navigate(`${location.pathname}?${newParams?.toString()}`);
                }}
                className=""
                key={v.key}
              >
                <div className="flex cursor-pointer items-center space-x-2">
                  <div className="flex h-[15px] w-[15px] items-center justify-center border-[1px] border-solid border-black p-[2px]">
                    {allSelectedOptions.includes(v.key) ||
                    (allSelectedOptions.includes(':1') && v.key === '*-1') ||
                    (allSelectedOptions.includes('1:') && v.key === '1-*') ||
                    (o.filterOptionId === 'pf_st_stock_status' &&
                      !allSelectedOptions.includes('out-of-stock')) ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-full"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z" />
                      </svg>
                    ) : null}
                  </div>
                  <div className="cursor-pointer font-light text-left">
                    {translatedKey} {`(${v?.doc_count ?? 0})`}
                  </div>
                </div>
              </button>
            );
          })}
    </div>
  );
}

function OptionSwatch({o}: {o: FilterOption}) {
  const location = useLocation();
  const params = React.useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const navigate = useNavigate();
  const allSelectedOptions = params.getAll(o.filterOptionId);
  return (
    <div className={clsx(['grid grid-cols-6 gap-2'])}>
      {o.displayType === 'swatch' &&
        Array.isArray(o.values) &&
        o.values
          .sort(function (a, b) {
            if (a.key < b.key) {
              return -1;
            }
            if (a.key > b.key) {
              return 1;
            }
            return 0;
          })
          .map((v) => {
            return (
              <button
                onClick={() => {
                  const newParams = filterInputToParams(
                    'SWATCH',
                    {val: v.key},
                    params,
                    o.filterOptionId,
                  );
                  navigate(`${location.pathname}?${newParams?.toString()}`);
                }}
                key={v.key}
                title={v.key}
              >
                <div className="flex cursor-pointer items-center space-x-2">
                  <div>
                    <div
                      className={clsx([
                        'h-[30px] w-[30px] rounded-full relative',
                        'before:border-2 before:border-white before:absolute before:top-[1px] before:left-[1px] before:right-[1px] before:bottom-[1px] before:z-[2] before:rounded-full',
                        'hover:before:opacity-100',
                        allSelectedOptions.includes(v.key)
                          ? 'before:opacity-100'
                          : 'before:opacity-0',
                        v.key === 'RED' && 'bg-hk-red',
                        v.key === 'BLUE' && 'bg-blue-500',
                        v.key === 'GREEN' && 'bg-green-500',
                        v.key === 'YELLOW' && 'bg-yellow-500',
                        v.key === 'BLACK' && 'bg-black',
                        v.key === 'WHITE' &&
                          'border-[1px] border-slate-400 bg-white',
                        allSelectedOptions.includes(v.key) &&
                          v.key === 'WHITE' &&
                          '!border-black',
                        v.key === 'ORANGE' && 'bg-orange-500',
                        v.key === 'PURPLE' && 'bg-purple-500',
                        v.key === 'PINK' && 'bg-pink-500',
                        v.key === 'GREY' && 'bg-slate-500',
                        v.key === 'BEIGE' && 'bg-beige',
                        v.key === 'BROWN' && 'bg-yellow-900',
                      ])}
                      style={{
                        backgroundImage:
                          v.key === 'MULTICOLOR'
                            ? `url(https://cdn.shopify.com/s/files/1/0470/6526/8386/files/multicolor-2.png?v=1626147913)`
                            : v.key === 'GOLD'
                            ? 'url(https://cdn.shopify.com/s/files/1/0470/6526/8386/files/gold_40d68dd4-18d8-4d41-8302-28606f6bffc8.png?v=1625474230)'
                            : v.key === 'BRONZE'
                            ? 'url(https://cdn.shopify.com/s/files/1/0470/6526/8386/files/bronze_32f1ad16-7a3a-478c-b7ad-2d46c6ed1099.jpg?v=1626147165)'
                            : 'none',
                        backgroundSize: 'cover',
                      }}
                    ></div>
                  </div>
                </div>
              </button>
            );
          })}
    </div>
  );
}

function OptionPriceRange({o}: {o: FilterOption}) {
  const priceRangeObj = o.values as PriceRange;

  const location = useLocation();
  const params = React.useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const navigate = useNavigate();

  const selectedPriceRange = params.get('pf_p_price');
  const selectedPriceMin = selectedPriceRange?.split(':')[0]
    ? parseFloat(selectedPriceRange?.split(':')[0])
    : priceRangeObj.min;
  const selectedPriceMax = selectedPriceRange?.split(':')[1]
    ? parseFloat(selectedPriceRange?.split(':')[1])
    : priceRangeObj.max;

  const [minPrice, setMinPrice] = React.useState(
    selectedPriceMin ? selectedPriceMin : priceRangeObj.min,
  );
  const [maxPrice, setMaxPrice] = React.useState(
    selectedPriceMax ? selectedPriceMax : priceRangeObj.max,
  );

  React.useEffect(() => {
    setMinPrice(selectedPriceMin);
    setMaxPrice(selectedPriceMax);
  }, [location.pathname, params]);

  return (
    <div className="px-2">
      <div className="mb-2 flex items-center justify-between">
        <span className="">
          {minPrice ? minPrice.toFixed(2) : priceRangeObj.min.toFixed(2)}
        </span>
        <span className="">&mdash;</span>
        <span className="">
          {maxPrice ? maxPrice.toFixed(2) : priceRangeObj.max.toFixed(2)}
        </span>
      </div>
      <div className="mb-4">
        <Slider
          min={priceRangeObj.min ?? 0}
          max={priceRangeObj.max ?? 100000}
          defaultValue={[minPrice, maxPrice]}
          value={[minPrice, maxPrice]}
          onValueCommit={(priceRange: number[]) => {
            // if (
            //   (minPrice === 0 || minPrice === priceRangeObj.min) &&
            //   (maxPrice === 0 || maxPrice === priceRangeObj.max)
            // )
            //   return;

            const price: {min?: number; max?: number} = {};
            if (minPrice !== 0) price.min = minPrice;
            if (maxPrice !== 0) price.max = maxPrice;

            const newParams = filterInputToParams(
              'PRICE_RANGE',
              {price},
              params,
              'pf_p_price',
            );
            navigate(`${location.pathname}?${newParams?.toString()}`);
          }}
          onValueChange={(priceRange: number[]) => {
            setMinPrice(priceRange[0] as number);
            setMaxPrice(priceRange[1] as number);
          }}
        />
      </div>

      <div className="flex items-center justify-between text-xs text-slate-400 opacity-75">
        <span className="">{priceRangeObj.min.toFixed(2)}</span>
        <span className="">{priceRangeObj.max.toFixed(2)}</span>
      </div>
    </div>
  );
}
